import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { AuthService, LinksService } from '@isophi/core-legacy';

@Component({
    selector: 'app-license-lock-modal',
    templateUrl: './license-lock-modal.component.html',
    styleUrls: ['./license-lock-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LicenseLockModalComponent {
  private readonly linksService = inject(LinksService);
  private readonly authService = inject(AuthService);

  @Input() title = '';
  @Input() text = '';
  @Input() contained = false;

  readonly managementPricingUrl = this.linksService.getManagementAppUrl({ redirect: '/settings/price-list' });
  readonly showPricingCta = !!this.authService.loggedUser?.teacher && (this.authService.loggedUser.teacher.isDirector() || this.authService.loggedUser.teacher.isManager());
}
